import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";

function RejectReasonModal({ open, onClose, onConfirm }) {
  const [reason, setReason] = useState("");

  const handleSubmit = () => {
    if (!reason.trim()) {
      alert("Lütfen reddetme sebebi girin.");
      return;
    }
    onConfirm(reason);
    setReason("");
  };

  if (!open) return null;

  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-40 bg-white/10 flex items-center justify-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          transition={{ duration: 0.25 }}
          className="relative z-50 bg-white p-6 rounded-2xl max-w-xl w-[90%] shadow-lg border border-gray-200"
        >
          <h2 className="text-2xl font-semibold text-gray-800 mb-4 border-b pb-2">
            Reddetme Nedeni
          </h2>

          <textarea
            className="w-full border border-gray-300 focus:border-blue-500 focus:ring-blue-500 rounded-xl p-3 text-sm resize-none shadow-sm transition-all duration-200"
            rows={4}
            placeholder="Sebep giriniz..."
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />

          <div className="flex justify-end mt-4 gap-3">
            {/* İptal Butonu */}
            <button
              onClick={() => { onClose(); setReason(""); }}
              className="px-4 py-2 rounded-md border text-gray-700 flex items-center gap-x-1 transition-colors duration-200 relative overflow-hidden"
            >
              <span>İptal</span>
              <span className="absolute top-0 left-0 w-full h-full pointer-events-none bg-white opacity-0 hover:opacity-10 transition-opacity duration-300 rounded-md"></span>
            </button>

            {/* Reddet Butonu */}
            <button
              onClick={handleSubmit}
              className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-md flex items-center gap-x-1 transition-colors duration-200 relative overflow-hidden"
            >
              <span>Reddet</span>
              <span className="absolute top-0 left-0 w-full h-full pointer-events-none bg-white opacity-0 hover:opacity-10 transition-opacity duration-300 rounded-md"></span>
            </button>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
}

export default RejectReasonModal;
